<template>
  <nav class="bottom-navigation" :class="[theme]" v-if="adminLogin">
    <button id="menu-btn" class="nav-btn menu-btn" @click="showMenu"></button>
    <!-- <router-link
      id="witrino-btn"
      class="nav-btn witrino-btn"
      :to="'/'"
    ></router-link> -->
    <router-link
      v-if="routeStorage?.BusinessToken"
      id="home-store-btn"
      class="nav-btn home-store-btn"
      :to="'/' + routeStorage?.BusinessToken"
    ></router-link>
    <router-link
      v-if="themeInfo?.info?.business.token"
      id="operators-btn"
      class="nav-btn operators-btn"
      :to="'/' + themeInfo?.info?.business.token + '/members'"
    ></router-link>
    <router-link
      v-if="routeStorage?.BusinessToken"
      id="products-btn"
      class="nav-btn products-btn"
      :to="'/' + routeStorage?.BusinessToken + '/products'"
    ></router-link>
    <!-- <router-link
      v-if="!this.token"
      id="customers-club-btn"
      class="nav-btn customers-club-btn"
      :to="'/' + 'customers-club'"
    ></router-link> -->

    <!-- <router-link
      v-if="routeStorage?.BusinessToken"
      id="business-home-btn"
      class="nav-btn business-home-btn"
      :to="'/' + routeStorage?.BusinessToken"
    ></router-link> -->
    <button
      v-if="!themeInfo?.info?.business.token"
      id="menu-btn"
      class="nav-btn search-btn"
      @click="alert('این بخش در دست توسعه است')"
    ></button>
  </nav>
  <transition name="fade">
    <nav class="menu-navigation" v-if="activeMenu" @click="showMenu">
      <ul class="menu-navigation-ul">
        <li class="user-profile">
          <!-- <img
            class="user-profile-img"
            src="@/assets/img/bottom-navigation/guest-avatar.svg"
            alt="guest-avatar"
          /> -->
          <svg
            class="user-profile-svg"
            xmlns="http://www.w3.org/2000/svg"
            width="254.997"
            height="159.024"
            viewBox="0 0 254.997 159.024"
          >
            <path
              id="Union_26"
              data-name="Union 26"
              d="M-4450.776,7315.021c-13.169-24.771-31.785-22.983-31.785-22.983h-33.9l-.022-98.869,127.96-.011v-.009l127.037.024-.007,98.841h-31.67s-19.893-1.764-33.061,23.007c-8.419,13.141-24.319,36.324-62.276,37.152C-4426.457,7351.345-4442.356,7328.162-4450.776,7315.021Z"
              transform="translate(4516.482 -7193.149)"
              fill="#30427d"
            />
          </svg>
          <div class="user-avatar-image-div">
            <img
              src="@/assets/img/bottom-navigation/default-avatar.png"
              alt=""
            />
          </div>
          <p class="user-name">{{ currentUser?.name || "کاربر مهمان" }}</p>
          <p class="user-mobile">
            {{ currentUser?.mobile || ". . . . . . . . . . ." }}
          </p>
          <h1 class="section-separator"></h1>
        </li>

        <!-- ======================================================================= -->
        <!-- ======================================================================= -->

        <!-- <li class="link-menu" v-if="currentUser?.token">
          <router-link class="option-card" to="/profile">
            <img src="@/assets/img/option-cards/profile.svg" alt="" />
            <p>پروفایل کاربر</p>
          </router-link>
        </li> -->

        <li class="link-menu">
          <router-link class="option-card" to="/user-cart/list">
            <img src="@/assets/img/option-cards/cart.svg" alt="" />
            <p>سبدخرید</p>
          </router-link>
        </li>

        <!-- <li class="link-menu">
          <router-link class="option-card" to="/following">
            <img src="@/assets/img/option-cards/following.svg" alt="" />
            <p>ویترین ها</p>
          </router-link>
        </li> -->

        <!-- ======================================================================= -->
        <!-- ======================================================================= -->

        <li class="link-menu">
          <a
            class="option-card"
            target="_blank"
            :href="
              'https://witrino.com/user/login-token?username=' +
              themeInfo?.info?.business.token +
              '&token=' +
              currentUser?.token
            "
          >
            <img src="@/assets/img/option-cards/admin-panel-btn.png" alt="" />
            <p>پنل کاربری</p>
          </a>
        </li>
        <li class="link-menu" v-if="currentUser?.token">
          <router-link class="option-card" to="/order/list">
            <img src="@/assets/img/option-cards/my-orders-icon.svg" alt="" />
            <p>لیست سفارشات</p>
          </router-link>
        </li>
        <!-- <li class="link-menu">
          <a class="option-card" href="/">
            <img src="@/assets/img/public/btn-icon/witrino-btn.svg" alt="" />
            <p>فالیزنت</p>
          </a>
        </li> -->
        <li class="link-menu" v-if="routeStorage?.BusinessToken">
          <router-link
            :to="'/' + routeStorage?.BusinessToken + '/gallery'"
            class="option-card"
          >
            <img src="@/assets/img/option-cards/gallery.svg" alt="" />
            <p>گالری</p>
          </router-link>
        </li>
        <li class="link-menu">
          <a
            :href="
              'https://www.google.com/maps/search/?api=1&query=' +
              themeInfo?.info?.business.lat +
              ',' +
              themeInfo?.info?.business.long
            "
            class="option-card"
          >
            <img src="@/assets/img/option-cards/map-pin.svg" alt="" />
            <p>مشاهده در نقشه</p>
          </a>
        </li>
        <li class="link-menu" v-if="!currentUser?.token">
          <router-link class="option-card" to="/auth/register">
            <img src="@/assets/img/option-cards/login.svg" alt="" />
            <p>ورود</p>
          </router-link>
        </li>

        <li class="link-menu" v-else>
          <a class="option-card" @click="exit()">
            <img src="@/assets/img/option-cards/logout.svg" alt="" />
            <p>خروج</p>
          </a>
        </li>
        <!-- <li class="link-menu">
          <a class="option-card" @click="adminLogin()">
            <img src="@/assets/img/option-cards/magic-wand.png" alt="" />
            <p>{{ title }}</p>
          </a>
        </li> -->

        <!-- ======================================================================= -->

        <template v-if="false">
          <p class="current_business_name">
            {{ themeInfo?.info?.business.company_name }}
          </p>
          <h1 class="section-separator"></h1>

          <li class="link-menu" v-if="routeStorage?.BusinessToken">
            <router-link
              :to="'/' + routeStorage?.BusinessToken + '/gallery'"
              class="option-card"
            >
              <img src="@/assets/img/option-cards/gallery.svg" alt="" />
              <p>گالری</p>
            </router-link>
          </li>
          <li class="link-menu">
            <a
              :href="
                'https://www.google.com/maps/search/?api=1&query=' +
                themeInfo?.info?.business.lat +
                ',' +
                themeInfo?.info?.business.long
              "
              class="option-card"
            >
              <img src="@/assets/img/option-cards/map-pin.svg" alt="" />
              <p>مشاهده در نقشه</p>
            </a>
          </li>
          <li class="link-menu">
            <a
              class="option-card"
              :href="
                'http://polotik.biz/sellers/' + themeInfo?.info?.business.id
              "
            >
              <img src="@/assets/img/option-cards/polotik.svg" alt="" />
              <p>صفحه پلُ تیک</p>
            </a>
          </li>
          <li class="link-menu">
            <a class="option-card">
              <img src="@/assets/img/option-cards/weblog.svg" alt="" />
              <p>بلاگ</p>
            </a>
          </li>
          <!-- <li class="link-menu">
          <router-link :to="'/' + token + '/followers'" class="option-card">
            <img src="@/assets/img/public/followers.svg" alt="" />
            <p>دنبال کنندگان</p>
          </router-link>
        </li> -->
        </template>
      </ul>
    </nav>
  </transition>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "BottomNavigation",
  props: ["theme"],
  data() {
    return {
      activeMenu: false,
      activeUlMenu: false,
      token: null,
      isManagerMode: false,
      title: "ورود مدیر (تست)",
      routeStorage: { BusinessToken: "", lastUserRoute: null },
    };
  },
  computed: {
    ...mapGetters({
      themeInfo: "theme/themeInfo",
      currentUser: "auth/login/userInfo",
    }),
  },
  methods: {
    ...mapMutations({
      setManagerMode: "setManagerMode",
      logout: "auth/login/logout",
    }),
    showMenu() {
      this.activeMenu = !this.activeMenu;
      this.activeUlMenu = !this.activeUlMenu;
      return this.activeMenu;
    },
    adminLogin() {
      this.isManagerMode = !this.isManagerMode;
      if (this.isManagerMode) {
        this.title = "خروج مدیر (تست)";
      } else {
        this.title = "ورود مدیر (تست)";
      }
      this.setManagerMode("normal");
      this.$emit("isManagerMode", this.isManagerMode);
    },
    exit() {
      this.isManagerMode = false;
      this.setManagerMode("normal");
      this.$emit("isManagerMode", this.isManagerMode);
      this.logout();
    },
    adminAccess() {
      console.log("**************************************");
      console.log("**************************************");
      console.log("current User = > " + this.currentUser?.id);
      console.log("current token = > " + this.currentToken);
      console.log("business Admin = > " + this.themeInfo.info?.admin.id);
      console.log("**************************************");
      console.log("**************************************");
      if (this.currentUser?.id == this.themeInfo.info?.admin.id) {
        this.isManagerMode = true;
      } else {
        this.isManagerMode = false;
      }
      this.setManagerMode("normal");
      this.$emit("isManagerMode", this.isManagerMode);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.adminAccess();
    });
    console.log(this.currentUser);

    if (localStorage.getItem("routeStorage"))
      this.routeStorage = {
        ...JSON.parse(localStorage.getItem("routeStorage")),
      };
    console.log("TTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTT");
    console.log(this.routeStorage?.BusinessToken);
    console.log("TTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTT");
  },
};
</script>
<style lang="css" scoped>
@import url(@/assets/style/components/BottomNavigation/BottomNavigation.css);
</style>
